import { maxLength, ValidationField, Validator } from "~/extensions/utils";
import validate from "validate.js";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { commonStore } from "~/store/CommonStore";
export class NyukyoshaFindConditionValidator extends Validator {
    constructor(data) {
        const constraints = {
            userCd: {
                length: maxLength(8),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            },
            userName: {
                length: maxLength(30),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            },
            nyukyokeiyakuNo: {
                length: maxLength(8),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            },
            nyukyoshaName: {
                length: maxLength(30),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            },
            buknCd: {
                length: maxLength(8),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            },
            buknName: {
                length: maxLength(30),
                hasMinimumConditionsNyukyosha: hasMinimumConditionsNyukyosha(data, commonStore.messages.PV0021)
            }
        };
        super(data, constraints);
        this.userCd = new ValidationField("userCd", data, constraints);
        this.userName = new ValidationField("userName", data, constraints);
        this.nyukyokeiyakuNo = new ValidationField("nyukyokeiyakuNo", data, constraints);
        this.nyukyoshaName = new ValidationField("nyukyoshaName", data, constraints);
        this.buknCd = new ValidationField("buknCd", data, constraints);
        this.buknName = new ValidationField("buknName", data, constraints);
    }
    userCd;
    userName;
    nyukyokeiyakuNo;
    nyukyoshaName;
    buknCd;
    buknName;
}
/** 検索ボタン押下時かつ、検索条件の「契約者コード」「契約者名」「入居契約No」「入居契約名」「物件コード」「物件名」が全て空かをチェックする */
validate.validators.hasMinimumConditionsNyukyosha = function (value, options, key, attributes) {
    if (!options.vm.isSearch) {
        return null;
    }
    if (isNullOrUndefined(options.vm.userCd) &&
        (isNullOrUndefined(options.vm.userName) || options.vm.userName === "") &&
        isNullOrUndefined(options.vm.nyukyokeiyakuNo) &&
        (isNullOrUndefined(options.vm.nyukyoshaName) || options.vm.nyukyoshaName === "") &&
        isNullOrUndefined(options.vm.buknCd) &&
        (isNullOrUndefined(options.vm.buknName) || options.vm.buknName === "")) {
        return options.message;
    }
    return null;
};
export function hasMinimumConditionsNyukyosha(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
